import { useAppSelector } from 'shared/lib';

import { useGetScores } from 'entities/scoring';
import { useChannel } from 'entities/siteSettings/lib';
import { isLoggedSelector } from 'entities/user';

import { updateScoreValueSelector } from '../model/updateScoreValue.selector';

export const useUpdateScoreValue = () => {
  const { isNeedUpdateScore, queryData } = useAppSelector(updateScoreValueSelector);
  const isLogged = useAppSelector(isLoggedSelector);
  const channel = useChannel();

  useGetScores(
    { ...queryData, channel },
    {
      skip: !isNeedUpdateScore || !isLogged,
    },
  );
};
